import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'pages';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const pageActions = { ...slice.actions, ...extraActions };
export const pagesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        pages: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/pages`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(baseUrl)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.pages = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.pages = action.payload;
            },
            [rejected]: (state, action) => {
                state.pages = { error: action.error };
            }
        };
    }
}
